import { render, staticRenderFns } from "./GameDetail.vue?vue&type=template&id=c73ac226&"
import script from "./GameDetail.vue?vue&type=script&lang=js&"
export * from "./GameDetail.vue?vue&type=script&lang=js&"
import style0 from "./GameDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports